import {
  Component,
  EventEmitter,
  Input,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ClassService } from '../../services/class.service';
import { map } from 'rxjs/operators';
import { DateUtils } from '../../utils/DateUtils';
import { Subscription, take } from 'rxjs';
import { ReservationService } from '../../services/reservation.service';
import { Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { CalendarComponent } from '../../ui/calendar.component';
import { SpinnerComponent } from '../../ui/spinner.component';
@Component({
  // `display: block` on the host: an Angular component element is inline by default,
  // and Tailwind's space-y-* sets margin-top, which does nothing on an inline box. As
  // an inline host this rendered with no vertical gap at all between siblings.
  host: { class: 'block' },
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CalendarComponent, SpinnerComponent],
})
export class DatePickerComponent {
  @Input() originIsAdminComponent: boolean = false;
  @Output() dateEventEmitter: EventEmitter<Date> = new EventEmitter<Date>();

  dateToday: Date = new Date();
  value?: Date;
  selectableDates: Date[] = [];
  disabledDatesSubscription: Subscription;
  initialLoad: boolean = true;
  componentLoaded: boolean = false;

  constructor(
    private classService: ClassService,
    private reservationService: ReservationService,
    private router: Router,
  ) {
    this.disabledDatesSubscription = classService
      .getClasses()
      .pipe(
        takeUntilDestroyed(),
        map((classes) => {
          return classes.map((oneClass) => new Date(oneClass.dateEpoch));
        }),
      )
      .subscribe((dates) => {
        this.selectableDates = dates;

        // If it's the first load then get the first available date and emit it
        if (this.initialLoad) {
          this.value = new Date();
          this.dateEventEmitter.emit(this.value);
          this.initialLoad = false;
        }

        this.componentLoaded = true;
      });
  }

  onDatePicked(date: Date): void {
    this.value = date;
    this.pickDate();
  }

  pickDate() {
    if (this.value && !this.originIsAdminComponent) {
      this.reservationService.setSelectedDate(this.value);
      this.router.navigate(['reserveer/class']);
    } else if (this.value) {
      this.dateEventEmitter.emit(this.value);
    }
  }
}
